export default __webpack_public_path__ + "static/media/AbrasiveBlastingImg.c52ec98c.jpg";